export const MOVING_COMPANIES_PATH = "moving-companies";
export const AUTO_SHIPPING_PATH = "auto-shipping";

export const BR_SITE_CONFIGURATION = {
	[MOVING_COMPANIES_PATH]: {
		showFeaturedCompany: true,
	},
	[AUTO_SHIPPING_PATH]: {
		showFeaturedCompany: true,
	},
};
